import React from 'react' 
import { Switch, Route, useRouteMatch, useHistory } from "react-router-dom"
import { ServiciosejecutadosAdminPage } from './admin/ServiciosejecutadosAdminPage'
 
import { PlanificacionSejecutadosPage } from './tabs/PlanificacionSejecutados/PlanificacionSejecutadosPage';

const ServiciosejecutadosRoutes = () => {
    const { path } = useRouteMatch();
    const history = useHistory()

    return (
        <Switch>
            <Route path={`${path}/servicios-ejecutados-admin`} render={(props) => (<ServiciosejecutadosAdminPage {...props} history={history} />)} />
            <Route path={`${path}/servicios-ejecutados/:id`} render={(props) => (<PlanificacionSejecutadosPage  {...props} history={history} />)} />
        </Switch>  
    )
}
export default ServiciosejecutadosRoutes; 
